import { supabase } from '@/lib/supabase'

export type RevsharePayout = {
  id: string
  user_id: string
  competence_month: string
  amount_cents: number
  fee_cents: number
  currency: string
  status: string
  scheduled_for: string | null
  paid_at: string | null
  method: string | null
  bank_account_id: string | null
  notes: string | null
  created_at: string
}

export async function listRevsharePayoutsPaged(
  userId: string,
  page = 1,
  pageSize = 25,
): Promise<{ rows: RevsharePayout[]; total: number }> {
  const from = (page - 1) * pageSize
  const to = from + pageSize - 1
  const { data, error, count } = await supabase
    .from('revshare_payouts')
    .select(
      'id, user_id, competence_month, amount_cents, fee_cents, currency, status, scheduled_for, paid_at, method, bank_account_id, notes, created_at',
      { count: 'exact' },
    )
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .range(from, to)
  if (error) throw error
  return { rows: (data as any) || [], total: count ?? 0 }
}

export async function listMyRevsharePayoutsPaged(page = 1, pageSize = 25) {
  const userId = (await supabase.auth.getUser()).data.user?.id
  if (!userId) return { rows: [] as RevsharePayout[], total: 0 }
  return listRevsharePayoutsPaged(userId, page, pageSize)
}

export type CreateRevsharePayoutInput = {
  user_id: string
  competence_month?: string | null
  commission_ids?: string[]
  method?: 'pix' | 'ted'
  bank_account_id?: string | null
  fee_cents?: number
  scheduled_for?: string | null
  notes?: string | null
}

export async function createRevsharePayout(input: CreateRevsharePayoutInput) {
  const { data, error } = await supabase.functions.invoke('admin-revshare-create-payout', { body: input })
  if (error) throw error
  return data as any
}

export async function finalizeRevsharePayout(payoutId: string) {
  const { data, error } = await supabase.functions.invoke('admin-revshare-finalize-payout', {
    body: { payout_id: payoutId },
  })
  if (error) throw error
  return data as any
}

export async function cancelRevsharePayout(payoutId: string) {
  const { data, error } = await supabase.functions.invoke('admin-revshare-cancel-payout', {
    body: { payout_id: payoutId },
  })
  if (error) throw error
  return data as any
}

